var __jsx = React.createElement;
import React from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { connect } from 'react-redux';
import { ModalGlobalStyle, Wrapper, ContentWrapper, Title, Text, ActionsWrapper, MainActionsWrapper } from './styles';
import Modal from '@spa/shared/components/Modal';
import QuestionIgnacio from '@spa/offer/svg/question-ignacio';
import Button from '@spa/shared/components/Unisystem/Button';
import { setIsCalendarOpenAction } from '@spa/offer/store/actions/offer';
var DoubleBookingModal = function DoubleBookingModal(_ref) {
  var setIsCalendarOpen = _ref.setIsCalendarOpen,
    onRequestBookingAnyway = _ref.onRequestBookingAnyway,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useRouter = useRouter(),
    locale = _useRouter.locale;
  var handleSeeCurrentBookings = function handleSeeCurrentBookings() {
    var languagePath = locale === 'en' ? '' : "".concat(locale, "/");
    window.location.href = "".concat(process.env.APP_URL).concat(languagePath, "dashboard/bookings");
  };
  var handleSelectNewDates = function handleSelectNewDates() {
    setIsCalendarOpen(true);
    onClose();
  };
  var handleRequestBookingAnyway = function handleRequestBookingAnyway() {
    onRequestBookingAnyway();
    onClose();
  };
  return __jsx(Modal, {
    className: "double-booking",
    onClose: onClose
  }, __jsx(ModalGlobalStyle, null), __jsx(Wrapper, null, __jsx(ContentWrapper, null, __jsx(QuestionIgnacio, null), __jsx(Title, null, t('You already have a confirmed booking for these dates'), "..."), __jsx(Text, null, t('If you send a new booking request and it gets accepted,'), ' ', __jsx("strong", null, t('you will be charged for a second booking.')))), __jsx(ActionsWrapper, null, __jsx(MainActionsWrapper, null, __jsx(Button, {
    isSecondary: true,
    onClick: handleSeeCurrentBookings
  }, t('See my current bookings')), __jsx(Button, {
    isPrimary: true,
    onClick: handleSelectNewDates
  }, t('Select new dates instead'))), __jsx(Button, {
    isSecondary: true,
    onClick: handleRequestBookingAnyway
  }, t('Send booking request anyway')))));
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setIsCalendarOpen: function setIsCalendarOpen(newValue) {
      return dispatch(setIsCalendarOpenAction({
        isCalendarOpen: newValue
      }));
    }
  };
};
export default connect(null, mapDispatchToProps)(DoubleBookingModal);